import React from 'react';
import { Field, FieldArray, reduxForm, initialize } from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';
import MenuItem from 'material-ui/MenuItem';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import FormSelect from '../../../components/FormSelect'
import FormLabel from '../../../components/FormLabel'
import FormAutoComplete2 from '../../../components/FormAutoComplete2'
import FormDatePicker from '../../../components/FormDatePicker'
import FormText from '../../../components/FormText'
import FormBizHolidayContents from '../../../components/FormBizHolidayContents'
import * as commons from '../../../commons';
import * as actions from '../../../actions';
import styles from '../../../styles'



const validateMonth = (month) => {

  if (!month || !month.length) {
    return []
  }

  let tmpList = []
  const monthErrors = []
  month.forEach((ele, index) => {
    const error = {}
    if (!ele.kind) {
      error.kind = '必須入力'
    }
    if (!ele.date) {
      error.date = '必須入力'
    } else {
      const date = moment(new Date(ele.date)).format('YYYY/MM/DD')

      if (tmpList.indexOf(date) >= 0) {
        error.date = '日付が重複しています'
      } else {
        tmpList.push(date)
      }
    }
    
    monthErrors[index] = error
  })

  return monthErrors

}

const validate = values => {
  const errors = {}

  for (let i = 0; i < 12; i++) {
    let monthErrors = validateMonth(values["month" + (i + 1)])
    if (monthErrors.length) {
      errors["month" + (i + 1)] = monthErrors
    }
  }

  return errors
}

class BizHolidayMasterForm extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {

    const { 
      initialValues,
      onRemoveDate,
      onRegist,
      onChangeYear,
      handleSubmit,
      error
    } = this.props

    const year = initialValues.year || (new Date()).getFullYear()

    return (

      <form onSubmit={() => {}}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}


        <div className="row">
          <div className="col">
            <Paper style={{...styles.yosanPaper, paddingTop: 0}}>
              <div className="row">
                <div className="col-3">
                  <Field
                    name='year'
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="対象年"
                    onChange={(e, index, value) => {
                      onChangeYear(index)
                    }}
                  >
                    <MenuItem value={2017} primaryText={'2017'} />
                    <MenuItem value={2018} primaryText={'2018'} />
                    <MenuItem value={2019} primaryText={'2019'} />
                    <MenuItem value={2020} primaryText={'2020'} />
                    <MenuItem value={2021} primaryText={'2021'} />
                    <MenuItem value={2022} primaryText={'2022'} />
                    <MenuItem value={2023} primaryText={'2023'} />
                    <MenuItem value={2024} primaryText={'2024'} />
                    <MenuItem value={2025} primaryText={'2025'} />
                    <MenuItem value={2026} primaryText={'2026'} />
                    <MenuItem value={2027} primaryText={'2027'} />
                    <MenuItem value={2028} primaryText={'2028'} />
                    <MenuItem value={2029} primaryText={'2029'} />
                    <MenuItem value={2030} primaryText={'2030'} />
                  </Field>
                </div>
              </div>
            </Paper>

          </div>
        </div>
        
        {
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => (

            <div className="row" key={x}>
              <div className="col">
                <Paper style={styles.yosanPaper}>

                  <h4 style={styles.yosanFormTitle}>{x}月</h4>

                  <Divider style={{ marginBottom: 10 }} />

                  <FieldArray
                    name={"month" + x}
                    component={FormBizHolidayContents}
                    dialogMonth={new Date(year, x - 1, 1)}
                    minDate={new Date(year, x - 1, 1)}
                    maxDate={new Date(year, x, 0)}
                    onRemoveDate={onRemoveDate}
                  />

                </Paper>
              </div>
            </div> 

          ))
        }


        {/* <div className="row" key={2}>
          <div className="col">
            <Paper style={styles.yosanPaper}>

              <h4 style={styles.yosanFormTitle}>{2}月</h4>

              <Divider style={{ marginBottom: 10 }} />

              <FieldArray
                name={"month" + 2}
                component={FormBizHolidayContents}
                dialogMonth={new Date(initialValues.year, 2 - 1, 1)}
                minDate={new Date(initialValues.year, 2 - 1, 1)}
                maxDate={new Date(initialValues.year, 2, 0)}

              />

            </Paper>
          </div>
        </div>  */}

{/* 
        <div className="row" key={2}>
          <div className="col">
            <Paper style={styles.yosanPaper}>

              <h4 style={styles.yosanFormTitle}>{2}月</h4>

              <Divider style={{ marginBottom: 10 }} />

              <FieldArray
                name={"month" + 2}
                component={FormBizHolidayContents}
                dialogMonth={new Date(initialValues.year, 2 - 1, 1)}
                minDate={new Date(initialValues.year, 2 - 1, 1)}
                maxDate={new Date(initialValues.year, 2, 0)}

              />

            </Paper>
          </div>
        </div> 

        {
          [1, 2].map(x => (

            <div className="row" key={x}>
              <div className="col">
                <Paper style={styles.yosanPaper}>

                  <h4 style={styles.yosanFormTitle}>{x}月</h4>

                  <Divider style={{ marginBottom: 10 }} />

                  <FieldArray
                    name={"month" + x}
                    component={FormBizHolidayContents}
                    dialogMonth={new Date(initialValues.year, x - 1, 1)}
                    minDate={new Date(initialValues.year, x - 1, 1)}
                    maxDate={new Date(initialValues.year, x, 0)}

                  />

                </Paper>
              </div>
            </div> 

          ))
        } */}

        <div style={styles.buttons}>

          <FlatButton
            label="登録"
            labelPosition="before"
            primary={true}
            labelStyle={{ color: colors.white, lineHeight: '40px' }}
            style={{ height: '40px', width: '100px' }}
            backgroundColor={colors.cyan700}
            hoverColor={colors.cyan900}
            icon={<DoneIcon color={colors.white} />}
            onClick={handleSubmit(onRegist)}
          />

        </div>

      </form>
    );
  }
};

BizHolidayMasterForm = reduxForm({
  form: 'bizHolidayMasterForm',
  enableReinitialize: true,
  validate,
  onSubmitFail: (errors, dispatch) => {
    dispatch(actions.reducerSnackBar(true, '入力内容に誤りがあります。', colors.red400))
  }
})(BizHolidayMasterForm)

export default BizHolidayMasterForm


// WEBPACK FOOTER //
// ./src/containers/master/bizHoliday/BizHolidayMasterForm.js